// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "travelCompanionFields-3T8Si";
var _4 = "formLabel-2LyG_";
var _5 = "formGroup-Bmq9i";
var _6 = "controlLabel-Qcw7I";
var _7 = "checkbox-Dpjnb";
var _8 = "checkbox__checked-1p68J";
var _9 = "checkbox__error-1p4hx";
var _a = "fieldLabel-3plyC";
var _b = "fieldLabel__name-3Fb2q";
var _c = "fieldLabel__date-1xM7w";
var _d = "travelCompanionFields__errorMessage-3FsnR";
export { _1 as "__esModule", _2 as "mobile", _3 as "travelCompanionFields", _4 as "formLabel", _5 as "formGroup", _6 as "controlLabel", _7 as "checkbox", _8 as "checkbox__checked", _9 as "checkbox__error", _a as "fieldLabel", _b as "fieldLabel__name", _c as "fieldLabel__date", _d as "travelCompanionFields__errorMessage" }
export default { "__esModule": _1, "mobile": _2, "travelCompanionFields": _3, "formLabel": _4, "formGroup": _5, "controlLabel": _6, "checkbox": _7, "checkbox__checked": _8, "checkbox__error": _9, "fieldLabel": _a, "fieldLabel__name": _b, "fieldLabel__date": _c, "travelCompanionFields__errorMessage": _d }
